import { Icon, HStack, Text, Stack } from '@chakra-ui/react';
import { IconType } from 'react-icons';

export type TableDataItem = {
  icon?: IconType;
  label?: string;
  value: string | number;
  comment?: string;
};

export const ParagraphList = ({
  data,
}: {
  data: TableDataItem[];
}) => {
  return (
    <Stack px="0" py="4" spacing="6">
      {data.map((item: TableDataItem, index) => {
        return (
          <Stack key={index}>
            {item.label && (
              <HStack spacing="2">
                {item.icon && item.value && (
                  <Icon as={item.icon} boxSize="5" />
                )}
                <Text
                  fontWeight="bold"
                  fontSize={item.value ? 'sm' : 'md'}
                >
                  {item.label}
                </Text>
              </HStack>
            )}
            {item.value && (
              <Text whiteSpace="pre-line" fontSize="sm">
                {item.value}
              </Text>
            )}
            {item.comment && (
              <Text whiteSpace="pre-line">{item.comment}</Text>
            )}
          </Stack>
        );
      })}
    </Stack>
  );
};
